class ErrorsPapelSegurancaHelper {
  static unique (sqlMessage) {
    // criamos um objeto com as unique
    // das tabela de papel de seguranca
    const errosUnique = {
      papel_seguranca_cartorio_id_numero_lote_unique: 'Número do lote já existe!',
      papel_seguranca_cartorio_id_prefixo_e_numero_inicial_unique: 'Prefixo e número inicial já existentes!',
      papel_seguranca_cartorio_id_prefixo_e_numero_final_unique: 'Prefixo e número final já existentes!',
    }

    const match = sqlMessage.match(/for key '(.*)'/i)

    if (match[1]) {
      // retornamos o erro unique com a mensagem devida
      return errosUnique[match[1]]
    }
  }
}

export default ErrorsPapelSegurancaHelper
